module.exports = __webpack_public_path__ + "static/media/2025-Sports-Masterclass-Mobile-Banner@1x.683f1b72.webp";